/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { selectAuthUser, selectOrganizationId } from 'modules/common/auth/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react'; import { ENVIRONMENT } from 'config';
import { isEmpty } from 'modules/common/helpers/object';
import PAGINATION from 'modules/common/constants/pagination-limits';
import TIME_OUTS from 'modules/common/constants/time-outs';
import ORDER_BY from 'modules/common/constants/order-by';
import { dashboardActions } from '../slice';
import { selectIsSessionTimedOut, selectTokenRevocation } from '../selectors';
/**
 * This is for fetching notifications from the server
 */
const useFetchNotifications = () => {
  const dispatch = useDispatch();
  //
  const organizationId = useSelector(selectOrganizationId);
  const isSessionTimedOut = useSelector(selectIsSessionTimedOut);
  const isTokenRevoked = useSelector(selectTokenRevocation);
  const authUser = useSelector(selectAuthUser);
  //
  useEffect(() => {
    dispatch(
      dashboardActions.getNotificationsList({
        organizationId,
        userId: authUser?.id,
        query: `limit=${PAGINATION.NOTIFICATIONS_LIST_COUNT}&notificationType=WEB&sortBy=createdAt:${ORDER_BY.DESCENDING}`,
      })
    );
    let intervalId;
    if (organizationId && !isEmpty(authUser) && !isSessionTimedOut && !isTokenRevoked) {
      intervalId = setInterval(() => {
        dispatch(
          dashboardActions.getNotificationsList({
            organizationId,
            userId: authUser?.id,
            query: `limit=${PAGINATION.NOTIFICATIONS_LIST_COUNT}&notificationType=WEB&sortBy=createdAt:${ORDER_BY.DESCENDING}`,
          })
        );
      }, TIME_OUTS.NOTIFICATION_INTERVAL);
      //
    }
    return () => clearInterval(intervalId);
  }, [organizationId, authUser, isSessionTimedOut, isTokenRevoked]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
   if (ENVIRONMENT.IS_VISUAL_INTERPRETER_ENABLED?.toLowerCase() === 'true' && ENVIRONMENT.IS_DATA_EXPORT_INTERPRETER_ENABLED?.toLowerCase() === 'false' ) {
      dispatch(
        dashboardActions.getProgressNotificationsList({
          organizationId,
          userId: authUser?.id,
          query: `limit=5&notificationType=WEB_LLM&isOpen=false&sortBy=createdAt:${ORDER_BY.DESCENDING}`,
        })
      );
      let intervalId;
      if (organizationId && !isEmpty(authUser) && !isSessionTimedOut && !isTokenRevoked) {
        intervalId = setInterval(() => {
          dispatch(
            dashboardActions.getProgressNotificationsList({
              organizationId,
              userId: authUser?.id,
              query: `limit=5&notificationType=WEB_LLM&isOpen=false&sortBy=createdAt:${ORDER_BY.DESCENDING}`,
            })
          );
        }, 15000);
        //
      }
      return () => clearInterval(intervalId);
    }
  }, [organizationId, authUser, isSessionTimedOut, isTokenRevoked]);
};
//
export default useFetchNotifications;
